import { CountryCode } from '../../i18n/countryCodes'
import mapValuesToRequest, { IRequestBody } from './mappers/mapValuesToRequest'

export default function(api: GlobalFetch) {
  return async function(user: IRequestValues): Promise<boolean> {
    const requestBody: IRequestBody = mapValuesToRequest(user)
    const response = await api.fetch(`/api/v2/user/update`, {
      body: JSON.stringify(requestBody),
      method: 'PUT',
    })

    if (response.status !== 200) {
      throw new Error('Updating user rejected')
    }

    return response.status === 200
  }
}

export interface IRequestValues {
  savedLang: CountryCode
  agreement?: boolean
  dateFormat?: string
  timeFormat?: string
}
